import React from 'react'
import { Users } from 'react-feather'
import './ContactsEmptyState.scss'

export function ContactsEmptyState() {
  return (
    <div className="contacts-empty-state">
      <Users className="contacts-empty-state__icon" size={48} strokeWidth={1} aria-hidden />
      <p className="contacts-empty-state__text">
        Nenhum contato ainda — envie sua planilha para começar
      </p>
    </div>
  )
}
